// @flow
import clsx from 'clsx';
import { Card, View, Radio, Text } from 'reshaped';

import styles from './RadioBlock.module.css';

export type Item = {
  id: string,
  name: string,
  [key: string]: any,
};

export type Props<T: Item> = {
  ...T,
  children?: React.Node,
  value: string,
  selected: boolean,
  renderLabel?: React.ComponentType<T>,
};

export function RadioBlock<T: Item>({
  children,
  value,
  selected,
  renderLabel: Label,
  ...props
}: Props<T>): React.MixedElement {
  return (
    <Card
      as="label"
      selected={selected}
      className={clsx(styles.root, selected && styles.selected)}
      attributes={{
        'aria-label': props.name,
      }}
    >
      <View
        direction="column"
        gap={2}
        backgroundColor="elevation-base"
        padding={6}
      >
        <View gap={3} direction="row" align="center">
          {/* $FlowFixMe: RadioGroupControlled */}
          <Radio value={value} />
          {(Label && <Label {...props} />) || props.name}
        </View>
        {!!children && <Text variant="body-3">{children}</Text>}
      </View>
    </Card>
  );
}
